/* eslint-disable no-console */
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { get, isEmpty } from 'lodash';

import { Box, Tabs, TabPanel, Dialog, Button } from 'components';
import ComingSoon from 'components/ComingSoon';
import { errorMessageHandler } from 'common/utils/helpers';
import { InviteUser } from 'common/types';
import { deleteUserService, userListService } from 'services';

import styles from './styles';
import AddUser from './components/AddUser';
import UserList from './components/UserList';

const Settings = () => {
  const classes = styles();
  const pathName = useLocation().pathname;
  const [value, setValue] = useState<number>(0);
  const [userList, setUserList] = useState<Array<InviteUser>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isOpen, setOpen] = useState<boolean>(false);
  const [user, setUser] = useState<InviteUser | null>(null);
  const [deleteAction, setDeleteAction] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const tabs = useMemo(() => {
    const tabsList = [
      { name: 'Access', key: 'ACCESS' },
      { name: 'Others', key: 'OTHERS' },
    ];

    return tabsList;
  }, []);

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const getUserList = async () => {
    try {
      setIsLoading(true);
      const response: any = await userListService();
      if (typeof get(response, 'data') !== 'string') {
        setUserList(get(response, 'data', []));
      }
      setIsLoading(false);
    } catch (err) {
      const message: string = errorMessageHandler(err);
      setIsLoading(false);
      setErrorMessage(message);
    }
  };

  const handleDialogOpen = (user: InviteUser) => {
    setUser(user);
    setOpen(true);
  };

  const handleDialogClose = () => {
    setUser(null);
    setDeleteAction(false);
    setErrorMessage('');
    setOpen(false);
  };

  const handleDeleteUser = async () => {
    try {
      if (!isEmpty(get(user, 'id'))) {
        setDeleteLoading(true);
        const response: any = await deleteUserService(get(user, 'id') || '');
        // eslint-disable-next-line no-console
        console.log(response);
        setDeleteLoading(false);
        getUserList();
        handleDialogClose();
      }
    } catch (err) {
      const message: string = errorMessageHandler(err);
      setDeleteLoading(false);
      setErrorMessage(message);
    }
  };

  useEffect(() => {
    if (value == 0) {
      getUserList();
    }
  }, [value]);

  return (
    <Box>
      {pathName === '/settings' && (
        <Box className={classes.mainHeader}>
          <Typography className={classes.mainHeaderText}>Settings</Typography>
        </Box>
      )}
      <ComingSoon />
      {/* TODO: remove condition for development */}
      {pathName === '/settingss' && (
        <>
          <Box
            className={
              pathName === '/settingss'
                ? classes.settingsCont
                : classes.profileSettingsCont
            }
          >
            <Tabs
              tabs={tabs}
              value={value}
              handleChange={handleChange}
              className={classes.tabsContainer}
            />
            <TabPanel value={value} index={0}>
              <Box className={classes.tabPanelContainer}>
                <UserList
                  userList={userList}
                  isLoading={isLoading}
                  errorMessage={!deleteAction ? errorMessage : ''}
                  handleDialogOpen={handleDialogOpen}
                  setDeleteAction={setDeleteAction}
                />
              </Box>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Box className={classes.tabPanelContainer}></Box>
            </TabPanel>
          </Box>
          <Dialog
            open={isOpen}
            maxWidth={'md'}
            className={classes.addUserModel}
            subheading={''}
            title={
              isEmpty(user)
                ? 'New User'
                : deleteAction
                ? 'Delete User'
                : 'Update User'
            }
            handleClose={() => {
              handleDialogClose();
            }}
            dialogAction={deleteAction}
            dialogActionChildren={
              <Box className={classes.submitCancelButtonBox}>
                <Button
                  type="submit"
                  variant="contained"
                  name="OK"
                  onClick={handleDeleteUser}
                  className={classes.submitButton}
                  isLoading={deleteLoading}
                  disabled={deleteLoading}
                />
                <Button
                  className={classes.cancelButton}
                  onClick={handleDialogClose}
                  name="Cancel"
                />
              </Box>
            }
          >
            {deleteAction ? (
              <>
                {errorMessage && (
                  <Typography variant="caption" className={classes.errorText}>
                    {errorMessage}
                  </Typography>
                )}
                <Typography variant="h5" className={classes.deleteUsertext}>
                  Are you sure, you want to delete the user?
                </Typography>
              </>
            ) : (
              <AddUser
                handleBack={() => setOpen(false)}
                user={user}
                getUserList={() => getUserList()}
              />
            )}
          </Dialog>
        </>
      )}
    </Box>
  );
};
export default Settings;
